<template>
    <div>
        <header class="panel__header">
            <h2 class="panel__title">Update payment method</h2>
        </header>
        <form @submit.prevent="submit()">
            <payment-method ref="paymentMethod"></payment-method>

            <div class="form__group">
                <a @click.prevent="$emit('page', 'plans')" href="#" class="button button--small button--link">Cancel</a>
                <button type="submit" class="lc-submit button button--primary button--small" :disabled="isProcessing || form.busy">Update</button>
            </div>
        </form>
    </div>
</template>
<script>
/* global EventBus */
import currentTenantAware from '../../../mixins/currentTenantAware'
import PaymentMethod from './PaymentMethod'
import Form from '../../../helpers/Form'

export default {
    mixins: [currentTenantAware],

    data () {
        return {
            isProcessing: false,
            form: new Form({
                payment_method_id: ''
            })
        }
    },

    methods: {
        submit () {
            if (this.isProcessing) {
                return
            }

            this.isProcessing = true

            this.$refs.paymentMethod.setup((intent) => {
                this.form.payment_method_id = intent.payment_method

                this.$store.dispatch('tenant/updatePaymentMethod', this.form).then(() => {
                    EventBus.$emit('newSnackbar', 'Payment method updated')
                    this.$emit('page', 'plans')
                })
            }).finally(() => {
                this.isProcessing = false
            })
        }
    },

    components: {
        PaymentMethod
    }
}
</script>
